export class RouteConstants {
  static readonly ROUTE_PROFILE = "/profile";
  static readonly ROUTE_GDPR_LIST = "/tickets";
  static readonly ROUTE_GDPR_CREATE = "/tickets/new";
  static readonly ROUTE_GDPR_VIEW = "/tickets/:id";
  static readonly ROUTE_CUSTOMIZATION = "/customization";
  static readonly ROUTE_NOT_FOUND = "/not-found";
}
